<template>
  <div class="clearfix">
    <a-upload
      :customRequest="upload"
      list-type="picture-card"
      :before-upload="beforeUpload"
      :file-list="fileList"
      :accept="accept=='image'?'image/*':'video/*'"
      :showUploadList="{showPreviewIcon:true , showRemoveIcon: !preview}"
      :remove="handRemove"
    >
      <div v-if="fileList.length < maxCount && !preview">
        <a-icon :type="uploadIcon" />
      </div>
    </a-upload>
  </div>
</template>
<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
function blobToDataURL(blob) {
  return new Promise((resolve,reject)=>{
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  })
}
function base64ConvertFile(urlData) {
  if (typeof urlData != 'string') {
    return;
  }
  var arr = urlData.split(',')
  var type = arr[0].match(/:(.*?);/)[1]
  var fileExt = type.split('/')[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], 'filename.' + fileExt, {
    type: type
  });
}
import { Video } from 'video-metadata-thumbnails';
import { uploadPOST } from "@/api/api";
export default {
  props: {
    list: Array,
    preview: {
      type: Boolean,
      value: false
    },
    maxCount: {
      type: Number,
      default: 6,
    },
    uploadIcon: {
      type: String,
      default: 'plus'
    },
    accept:{
      type: String,
      default: 'image'
    }
  },
  computed:{
    fileList:{
      get(){
        this.list.forEach(e => {
          e.name= e.url;
          e.uid= e.url;
        });
        return this.list;
      },
      set(newVal){
        console.log(newVal);
      }
    }
  },
  data() {
    return {
      filterAccept: {'image':this.$t('page_ops_work_record_photo'),'video': this.$t("page_ops_work_record_video")}
    };
  },
  methods: {
    beforeUpload(file) {
      if(file.type.indexOf(this.accept)==-1){
        this.$message.error(`${this.$t("page_ops_work_record_type")} ${this.filterAccept[this.accept]}`);
        return false;
      }
      if(file.type.indexOf('video')!==-1){
        if( file.size / 1024 / 1024 > 20){
          this.$message.error(`${this.$t('page_ops_work_record_video_over')} 20M`);
          return false;
        }
      }
      if(file.type.indexOf('image')!==-1){
        if (file.size / 1024 / 1024 > 2) {
          this.$message.error(`${this.$t('page_ops_work_record_Image_over')} 2M`);
          return false;
        }
      }
      return true;
    },
    handRemove(f) {
      this.$confirm({
        content: this.$t('page_role_management_delete_or_not'),
        onOk: () => {
          const index = this.fileList.indexOf(this.fileList.find(v => v.url === f.url))
          this.fileList.splice(index, 1);
          this.$emit('fileList',this.fileList);
        },
      })
      
    },
    async getThumb(f){
      const b = new Blob([f.file],{type: 'audio/*'});
      const video = new Video(b);
      const thumbnails = await video.getThumbnails({
        quality: 0.7,
        start: 0,
        end: 0
      })
      const thumb64 = await blobToDataURL(thumbnails[0].blob);
      const thumbFile = base64ConvertFile(thumb64);
      return thumbFile;
    },
    async upload(f){
      switch (this.accept) {
        case 'image':
          const imageRes = await this.http(f.file);
          this.fileList.push({uid:imageRes.link, type:this.accept, thumb:'', name:imageRes.link, url:imageRes.link});
          break;
      
        case 'video':
          const thumbFile = await this.getThumb(f);
          const videoRes = await this.http(f.file);
          const thumb = await this.http(thumbFile);
          this.fileList.push({uid:videoRes.link, type:this.accept, name:videoRes.link, thumb:thumb.link, url:videoRes.link});
          break;
      }
      this.$emit('fileList',this.fileList);
    },  
    http(file){
      return new Promise((resovle,reject)=>{
        const formData = new FormData();
        formData.append("file", file);
        uploadPOST(formData).then(res=>{
          resovle(res.data.data)
        }).catch(err=>{
          reject();
        })
      })

    }
  },
};
</script>
<style>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
